import React, { useState, useEffect, useRef } from "react"

const HEIGHT = 80

const TextArea = ({
  id,
  name,
  defaultValue,
  title,
  onChange,
  placeholder,
  onPaste,
  onDrop,
  onKeyDown,
  onSelect,
  onBlur,
  rows,
  readOnly,
  className     = "form-control",
  required      = false,
  defaultHeight = HEIGHT,
}) => {
  const [value, setValue] = useState(defaultValue || "")
  const valueRef = useRef(null)

  useEffect(() => {
    setValue(defaultValue || "")
  }, [defaultValue])

  const handleChange = (e) => {
    setValue(e.target.value)
    if (onChange) onChange(e.target.value)
  }

  useEffect(() => {
    if (valueRef.current) {
      valueRef.current.style.height = 'auto'
      valueRef.current.style.height = `${valueRef.current.scrollHeight}px`
    }
  }, [value])

  return (
    <textarea
      ref         = {valueRef}
      id          = {id}
      name        = {name}
      title       = {title}
      className   = {className}
      value       = {value}
      onChange    = {handleChange}
      required    = {required}
      placeholder = {placeholder}
      onPaste     = {onPaste}
      onDrop      = {onDrop}
      onKeyDown   = {onKeyDown}
      onSelect    = {onSelect}
      onBlur      = {onBlur}
      rows        = {rows}
      readOnly    = {readOnly}
      style       = {{ height: `${defaultHeight}px`, minHeight: defaultHeight, overflow: "hidden", resize: "none" }}
    />
  )
}

export default TextArea
